import { VertragCarousel } from '@/domain/vertraege/features/VertragCarousel/VertragCarousel';
import { useVertraege } from '@/domain/vertraege/shared/hooks/useVertraege';
import { Helmet } from 'react-helmet-async';
import { useTranslation } from 'react-i18next';

export function Page() {
  const { t } = useTranslation();
  const { vertraege } = useVertraege();

  return (
    <>
      <Helmet>
        <title>{t('domain.vertraege.navigation')}</title>
      </Helmet>
      <div className="flex flex-col gap-8">
        <div className="flex justify-between items-start">
          <div className="flex flex-col justify-start gap-3">
            <h2 className="font-extrabold text-2xl">
              {t('domain.vertraege.header')}
            </h2>
            <div className="text-sm text-neutrals-800">
              {t('domain.vertraege.subtitle')}
            </div>
          </div>
          <div className="text-neutrals-900 leading-none dark:text-white">
            {vertraege.length} {t('domain.vertraege.info.vertraege')}
          </div>
        </div>
      </div>
      <VertragCarousel />
    </>
  );
}
